export const movie = {
    "page": 1,
    "results": [
        {
            "adult": false,
            "backdrop_path": "/xDMIl84Qo5Tsu62c9DGWhmPI67A.jpg",
            "genre_ids": [
                28,
                12,
                878
            ],
            "id": 505642,
            "original_language": "en",
            "original_title": "Black Panther: Wakanda Forever",
            "overview": "Queen Ramonda, Shuri, M’Baku, Okoye and the Dora Milaje fight to protect their nation from intervening world powers in the wake of King T’Challa’s death.  As the Wakandans strive to embrace their next chapter, the heroes must band together with the help of War Dog Nakia and Everett Ross and forge a new path for the kingdom of Wakanda.",
            "popularity": 1947.255,
            "poster_path": "/sv1xJUazXeYqALzczSZ3O6nkH75.jpg",
            "release_date": "2022-11-09",
            "title": "Black Panther: Wakanda Forever",
            "video": false,
            "vote_average": 7.3,
            "vote_count": 4083
        },
        {
            "adult": false,
            "backdrop_path": "/jr8tSoJGj33XLgFBy6lmZhpGQNu.jpg",
            "genre_ids": [
                16,
                12,
                35,
                10751
            ],
            "id": 315162,
            "original_language": "en",
            "original_title": "Puss in Boots: The Last Wish",
            "overview": "Puss in Boots discovers that his passion for adventure has taken its toll: He has burned through eight of his nine lives, leaving him with only one life left. Puss sets out on an epic journey to find the mythical Last Wish and restore his nine lives.",
            "popularity": 2176.668,
            "poster_path": "/kuf6dutpsT0vSVehic3EZIqkOBt.jpg",
            "release_date": "2022-12-07",
            "title": "Puss in Boots: The Last Wish",
            "video": false,
            "vote_average": 8.4,
            "vote_count": 4587
        },
        {
            "adult": false,
            "backdrop_path": "/22z44LPkMyf5nyyXvv8qQLsbom.jpg",
            "genre_ids": [
                27,
                9648,
                53
            ],
            "id": 631842,
            "original_language": "en",
            "original_title": "Knock at the Cabin",
            "overview": "While vacationing at a remote cabin, a young girl and her two fathers are taken hostage by four armed strangers who demand that the family make an unthinkable choice to avert the apocalypse. With limited access to the outside world, the family must decide what they believe before all is lost.",
            "popularity": 1845.564,
            "poster_path": "/dm06L9pxDOL9jNSK4Cb6y139rrG.jpg",
            "release_date": "2023-02-01",
            "title": "Knock at the Cabin",
            "video": false,
            "vote_average": 6.5,
            "vote_count": 1003
        },
        {
            "adult": false,
            "backdrop_path": "/pxJbfnMIQQxCrdeLD0zQnWr6ouL.jpg",
            "genre_ids": [
                28,
                35,
                53
            ],
            "id": 1077280,
            "original_language": "en",
            "original_title": "Die Hart",
            "overview": "Kevin Hart - playing a version of himself - is on a death-defying quest to become an action star. And with a little help from John Travolta, Nathalie Emmanuel, and Josh Hartnett - he just might pull it off.",
            "popularity": 1665.507,
            "poster_path": "/1EnBjTJ5utgT1OXYBZ8YwByRCzP.jpg",
            "release_date": "2023-02-22",
            "title": "Die Hart",
            "video": false,
            "vote_average": 6.2,
            "vote_count": 178
        },
        {
            "adult": false,
            "backdrop_path": "/r7Dfg9aRZ78gJsmDlCirIIlNH3d.jpg",
            "genre_ids": [
                18
            ],
            "id": 785084,
            "original_language": "en",
            "original_title": "The Whale",
            "overview": "A reclusive English teacher suffering from severe obesity attempts to reconnect with his estranged teenage daughter for one last chance at redemption.",
            "popularity": 1951.845,
            "poster_path": "/jQ0gylJMxWSL490sy0RrPj1Lj7e.jpg",
            "release_date": "2022-12-09",
            "title": "The Whale",
            "video": false,
            "vote_average": 8,
            "vote_count": 1165
        },
        {
            "adult": false,
            "backdrop_path": "/AsEgGeccI32SwMBkxpwhOkhbzmF.jpg",
            "genre_ids": [
                28,
                878,
                53,
                27
            ],
            "id": 1011679,
            "original_language": "en",
            "original_title": "Shark Side of the Moon",
            "overview": "Decades ago, the USSR developed unkillable sharks and launched them to the moon. Today, a team of American astronauts will endure the fight of their lives.",
            "popularity": 1520.139,
            "poster_path": "/v5CfpzxoJDkZxjZAizClFdlEF0U.jpg",
            "release_date": "2022-08-12",
            "title": "Shark Side of the Moon",
            "video": false,
            "vote_average": 5.3,
            "vote_count": 89
        },
        {
            "adult": false,
            "backdrop_path": "/9Rq14Eyrf7Tu1xk0Pl7VcNbNh1n.jpg",
            "genre_ids": [
                28,
                12,
                53
            ],
            "id": 646389,
            "original_language": "en",
            "original_title": "Plane",
            "overview": "After a heroic job of successfully landing his storm-damaged aircraft in a war zone, a fearless pilot finds himself between the agendas of multiple militias planning to take the plane and its passengers hostage.",
            "popularity": 1318.216,
            "poster_path": "/qi9r5xBgcc9KTxlOLjssEbDgO0J.jpg",
            "release_date": "2023-01-12",
            "title": "Plane",
            "video": false,
            "vote_average": 6.9,
            "vote_count": 879
        },
        {
            "adult": false,
            "backdrop_path": "/2Eewgp7o5AU1xCataDmiIL2nYxd.jpg",
            "genre_ids": [
                18,
                36
            ],
            "id": 943822,
            "original_language": "en",
            "original_title": "Prizefighter: The Life of Jem Belcher",
            "overview": "At the turn of the 19th century, Pugilism was the sport of kings and a gifted young boxer fought his way to becoming champion of England.",
            "popularity": 2083.48,
            "poster_path": "/x3PIk93PTbxT88ohfeb26L1VpZw.jpg",
            "release_date": "2022-06-30",
            "title": "Prizefighter: The Life of Jem Belcher",
            "video": false,
            "vote_average": 6.9,
            "vote_count": 35
        },
        {
            "adult": false,
            "backdrop_path": "/ovM06PdF3M8wvKb06i4sjW3xoww.jpg",
            "genre_ids": [
                878,
                12,
                28
            ],
            "id": 76600,
            "original_language": "en",
            "original_title": "Avatar: The Way of Water",
            "overview": "Set more than a decade after the events of the first film, learn the story of the Sully family (Jake, Neytiri, and their kids), the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
            "popularity": 1104.179,
            "poster_path": "/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg",
            "release_date": "2022-12-14",
            "title": "Avatar: The Way of Water",
            "video": false,
            "vote_average": 7.7,
            "vote_count": 5740
        },
        {
            "adult": false,
            "backdrop_path": "/5i6SjyDbDWqyun8klUuCxrlFbyw.jpg",
            "genre_ids": [
                18
            ],
            "id": 677179,
            "original_language": "en",
            "original_title": "Creed III",
            "overview": "After dominating the boxing world, Adonis Creed has been thriving in both his career and family life. When a childhood friend and former boxing prodigy, Damien Anderson, resurfaces after serving a long sentence in prison, he is eager to prove that he deserves his shot in the ring. The face-off between former friends is more than just a fight. To settle the score, Adonis must put his future on the line to battle Damien - a fighter who has nothing to lose.",
            "popularity": 1218.53,
            "poster_path": "/vJU3rXSP9hwUuLeq8IpfsJShLOk.jpg",
            "release_date": "2023-03-01",
            "title": "Creed III",
            "video": false,
            "vote_average": 7,
            "vote_count": 330
        },
        {
            "adult": false,
            "backdrop_path": "/v2LilmCylr3bL9TCZSj6syjowZh.jpg",
            "genre_ids": [
                35,
                18
            ],
            "id": 937278,
            "original_language": "en",
            "original_title": "A Man Called Otto",
            "overview": "When a lively young family moves in next door, grumpy widower Otto Anderson meets his match in a quick-witted, pregnant woman named Marisol, leading to an unlikely friendship that turns his world upside down.",
            "popularity": 842.437,
            "poster_path": "/130H1gap9lFfiTF9iDrqNIkFvC9.jpg",
            "release_date": "2022-12-28",
            "title": "A Man Called Otto",
            "video": false,
            "vote_average": 7.9,
            "vote_count": 720
        },
        {
            "adult": false,
            "backdrop_path": "/dlrWhn0G3AtxYUx2D9P2bmzcsvF.jpg",
            "genre_ids": [
                878,
                27,
                35
            ],
            "id": 536554,
            "original_language": "en",
            "original_title": "M3GAN",
            "overview": "A brilliant toy company roboticist uses artificial intelligence to develop M3GAN, a life-like doll programmed to emotionally bond with her newly orphaned niece. But when the doll's programming works too well, she becomes overprotective of her new friend with terrifying results.",
            "popularity": 893.412,
            "poster_path": "/d9nBoowhjiiYc4FBNtQkPY7c11H.jpg",
            "release_date": "2022-12-28",
            "title": "M3GAN",
            "video": false,
            "vote_average": 7.4,
            "vote_count": 2037
        },
        {
            "adult": false,
            "backdrop_path": "/tt79dbOPd9Z9ykEOpvckttgYXwH.jpg",
            "genre_ids": [
                28,
                12,
                878
            ],
            "id": 545611,
            "original_language": "en",
            "original_title": "Everything Everywhere All at Once",
            "overview": "An aging Chinese immigrant is swept up in an insane adventure, where she alone can save what's important to her by connecting with the lives she could have led in other universes.",
            "popularity": 1039.668,
            "poster_path": "/rKvCys0fMIIi1X9rmJBxTPLAtoU.jpg",
            "release_date": "2022-03-24",
            "title": "Everything Everywhere All at Once",
            "video": false,
            "vote_average": 8,
            "vote_count": 3680
        },
        {
            "adult": false,
            "backdrop_path": "/k4V6EvpcOsu8CX10JD0H53lFXLq.jpg",
            "genre_ids": [
                53,
                28,
                18,
                80
            ],
            "id": 1058949,
            "original_language": "en",
            "original_title": "Little Dixie",
            "overview": "Erstwhile Special Forces operative Doc Alexander is asked to broker a truce with the Mexican drug cartel in secrecy. When Oklahoma Governor Richard Jeffs celebrates the execution of a high-ranking cartel member on TV, his Chief of Staff and Doc inform him about the peace he just ended. But it’s too late, as Cuco, the cartel’s hatchet man, has set his vengeful sights on Doc’s daughter Dixie.",
            "popularity": 956.874,
            "poster_path": "/cmWTZj9zzT9KFt3XyL0gssL7Ig8.jpg",
            "release_date": "2023-02-03",
            "title": "Little Dixie",
            "video": false,
            "vote_average": 6,
            "vote_count": 77
        },
        {
            "adult": false,
            "backdrop_path": "/A2avUoNFstnBhAnHiogXQs4c9Bt.jpg",
            "genre_ids": [
                18,
                27,
                9648
            ],
            "id": 772515,
            "original_language": "es",
            "original_title": "Huesera",
            "overview": "Valeria's joy at becoming a first-time mother is quickly taken away when she's cursed by a sinister entity. As danger closes in, she's forced deeper into a chilling world of dark magic that threatens to consume her.",
            "popularity": 725.318,
            "poster_path": "/1mZcxuL4GLUvPdEXC4iZPjG2EO3.jpg",
            "release_date": "2023-02-10",
            "title": "Huesera: The Bone Woman",
            "video": false,
            "vote_average": 5.8,
            "vote_count": 141
        },
        {
            "adult": false,
            "backdrop_path": "/af1tFYzzT2mHIy2l7nTIU8PWfak.jpg",
            "genre_ids": [
                80,
                18,
                53
            ],
            "id": 842942,
            "original_language": "en",
            "original_title": "Bandit",
            "overview": "After escaping a Michigan prison, a charming career criminal assumes a new identity in Canada and goes on to rob a record 59 banks and jewellery stores while being hunted by a rogue task force. Based on the story of The Flying Bandit.",
            "popularity": 881.77,
            "poster_path": "/yph9PAbmjYPvyvbeZvdYIhCZHEu.jpg",
            "release_date": "2022-09-23",
            "title": "Bandit",
            "video": false,
            "vote_average": 6.1,
            "vote_count": 122
        },
        {
            "adult": false,
            "backdrop_path": "/ae4xZiU7IeFVrvXxm2GjdcTrBm.jpg",
            "genre_ids": [
                27,
                9648,
                53
            ],
            "id": 934433,
            "original_language": "en",
            "original_title": "Scream VI",
            "overview": "Following the latest Ghostface killings, the four survivors leave Woodsboro behind and start a fresh chapter.",
            "popularity": 966.423,
            "poster_path": "/aePBN8ffLCHoUXp8lkA5P29CXdx.jpg",
            "release_date": "2023-03-08",
            "title": "Scream VI",
            "video": false,
            "vote_average": 7.4,
            "vote_count": 219
        },
        {
            "adult": false,
            "backdrop_path": "/32GH8Mi4GmTPIQyd6IW1FFrHWrj.jpg",
            "genre_ids": [
                28
            ],
            "id": 965839,
            "original_language": "en",
            "original_title": "Lord of the Streets",
            "overview": "When Jason Dyson refuses to make his prized fighter throw an MMA match, a notorious gangster collects his debt by killing the fighter and kidnapping Jason's daughter. Now he must train a prisoner to endure five consecutive underground fights to save her.",
            "popularity": 821.888,
            "poster_path": "/n9YWVQRc0zw0nwrFcOkOpffZxjc.jpg",
            "release_date": "2022-04-22",
            "title": "Lord of the Streets",
            "video": false,
            "vote_average": 5.4,
            "vote_count": 44
        },
        {
            "adult": false,
            "backdrop_path": "/xnAi4BRoO3ZQ3wwxGn6UNoxQzDq.jpg",
            "genre_ids": [
                80,
                28
            ],
            "id": 823999,
            "original_language": "it",
            "original_title": "Diabolik - Ginko all'attacco!",
            "overview": "Diabolik nearly gets caught in Inspector Ginko's latest trap, leaving his partner in crime Eva Kant behind in the escape. Furious, Eva offers Ginko her help in capturing the King of Terror, but the former has to face the return of an old flame of his.",
            "popularity": 833.97,
            "poster_path": "/8QVbWBv94BAT9u1q9uJccwOxMzt.jpg",
            "release_date": "2022-11-17",
            "title": "Diabolik - Ginko Attacks",
            "video": false,
            "vote_average": 5.6,
            "vote_count": 103
        },
        {
            "adult": false,
            "backdrop_path": "/zGoZB4CboMzY1z4G3nU6BWnMDB2.jpg",
            "genre_ids": [
                28,
                10749,
                35
            ],
            "id": 758009,
            "original_language": "en",
            "original_title": "Shotgun Wedding",
            "overview": "Darcy and Tom gather their families for the ultimate destination wedding but when the entire party is taken hostage, “’Til Death Do Us Part” takes on a whole new meaning in this hilarious, adrenaline-fueled adventure as Darcy and Tom must save their loved ones—if they don’t kill each other first.",
            "popularity": 783.082,
            "poster_path": "/t79ozwWnwekO0ADIzsFP1E5SkvR.jpg",
            "release_date": "2022-12-28",
            "title": "Shotgun Wedding",
            "video": false,
            "vote_average": 6.3,
            "vote_count": 648
        }
    ],
    "total_pages": 37456,
    "total_results": 749110,
    posterbaseURl: 'https://image.tmdb.org/t/p/w300/'
}
export const configurationDB = {
    "images": {
        "base_url": "http://image.tmdb.org/t/p/",
        "secure_base_url": "https://image.tmdb.org/t/p/",
        "backdrop_sizes": [
            "w300",
            "w780",
            "w1280",
            "original"
        ],
        "logo_sizes": [
            "w45",
            "w92",
            "w154",
            "w185",
            "w300",
            "w500",
            "original"
        ],
        "poster_sizes": [
            "w92",
            "w154",
            "w185",
            "w342",
            "w500",
            "w780",
            "original"
        ],
        "profile_sizes": [
            "w45",
            "w185",
            "h632",
            "original"
        ],
        "still_sizes": [
            "w92",
            "w185",
            "w300",
            "original"
        ]
    },
    "change_keys": [
        "adult",
        "air_date",
        "also_known_as",
        "alternative_titles",
        "biography",
        "birthday",
        "budget",
        "cast",
        "certifications",
        "character_names",
        "created_by",
        "crew",
        "deathday",
        "episode",
        "episode_number",
        "episode_run_time",
        "freebase_id",
        "freebase_mid",
        "general",
        "genres",
        "guest_stars",
        "homepage",
        "images",
        "imdb_id",
        "languages",
        "name",
        "network",
        "origin_country",
        "original_name",
        "original_title",
        "overview",
        "parts",
        "place_of_birth",
        "plot_keywords",
        "production_code",
        "production_companies",
        "production_countries",
        "releases",
        "revenue",
        "runtime",
        "season",
        "season_number",
        "season_regular",
        "spoken_languages",
        "status",
        "tagline",
        "title",
        "translations",
        "tvdb_id",
        "tvrage_id",
        "type",
        "video",
        "videos"
    ]
}

export const genres =  [
        {
            "id": 28,
            "name": "Action"
        },
        {
            "id": 12,
            "name": "Adventure"
        },
        {
            "id": 16,
            "name": "Animation"
        },
        {
            "id": 35,
            "name": "Comedy"
        },
        {
            "id": 80,
            "name": "Crime"
        },
        {
            "id": 99,
            "name": "Documentary"
        },
        {
            "id": 18,
            "name": "Drama"
        },
        {
            "id": 10751,
            "name": "Family"
        },
        {
            "id": 14,
            "name": "Fantasy"
        },
        {
            "id": 36,
            "name": "History"
        },
        {
            "id": 27,
            "name": "Horror"
        },
        {
            "id": 10402,
            "name": "Music"
        },
        {
            "id": 9648,
            "name": "Mystery"
        },
        {
            "id": 10749,
            "name": "Romance"
        },
        {
            "id": 878,
            "name": "Science Fiction"
        },
        {
            "id": 10770,
            "name": "TV Movie"
        },
        {
            "id": 53,
            "name": "Thriller"
        },
        {
            "id": 10752,
            "name": "War"
        },
        {
            "id": 37,
            "name": "Western"
        }
    ]
export const singleMovie = {
    "adult": false,
    "backdrop_path": "/pxJbfnMIQQxCrdeLD0zQnWr6ouL.jpg",
    "belongs_to_collection": null,
    "budget": 0,
    "genres": [
        {
            "id": 28,
            "name": "Action"
        },
        {
            "id": 35,
            "name": "Comedy"
        },
        {
            "id": 53,
            "name": "Thriller"
        }
    ],
    "homepage": "https://www.amazon.com/dp/B0B6B6B9RY/",
    "id": 1077280,
    "imdb_id": "tt26198528",
    "original_language": "en",
    "original_title": "Die Hart",
    "overview": "Kevin Hart - playing a version of himself - is on a death-defying quest to become an action star. And with a little help from John Travolta, Nathalie Emmanuel, and Josh Hartnett - he just might pull it off.",
    "popularity": 1665.507,
    "poster_path": "/1EnBjTJ5utgT1OXYBZ8YwByRCzP.jpg",
    "production_companies": [
        {
            "id": 40268,
            "logo_path": "/shdAxUj8uF6exNLrF0kSqYVxCzG.png",
            "name": "HartBeat Productions",
            "origin_country": "US"
        }
    ],
    "production_countries": [
        {
            "iso_3166_1": "US",
            "name": "United States of America"
        }
    ],
    "release_date": "2023-02-22",
    "revenue": 0,
    "runtime": 85,
    "spoken_languages": [
        {
            "english_name": "English",
            "iso_639_1": "en",
            "name": "English"
        }
    ],
    "status": "Released",
    "tagline": "Live to change",
    "title": "Die Hart",
    "video": false,
    "vote_average": 6.2,
    "vote_count": 178,
    "videos": {
        "results": [
            {
                "iso_639_1": "en",
                "iso_3166_1": "US",
                "name": "Die Hart | Official Trailer | Prime Video ZA",
                "key": "pGNv5-dyRKA",
                "site": "YouTube",
                "size": 1080,
                "type": "Trailer",
                "official": false,
                "published_at": "2023-01-26T13:52:43.000Z",
                "id": "63f8d06f68b1ea009e001c45"
            }
        ]
    }
}




// export const newArray = console.log(configurationDB.change_keys.keys);

// export const operationArray = (second) => {
//     console.log(configurationDB.change_keys.keys);
// }


// export const FirstOperationArray = (second) => {
//     const array = configurationDB.change_keys
//         .map((key, val) => {
//             return {
//                 key: val,
//                 val: key,
//             };
//         })
//     console.log(array);
//     return genres.filter(f => movie?.results[0]?.genre_ids.some(item => item === f.id))
// }
// export let newObjkeyArray = FirstOperationArray()